__turbopack_context__.v({
  "accountLink": "UniverseLanding-module__kHG5Ha__accountLink",
  "brand": "UniverseLanding-module__kHG5Ha__brand",
  "brandAccent": "UniverseLanding-module__kHG5Ha__brandAccent",
  "cardLink": "UniverseLanding-module__kHG5Ha__cardLink",
  "cardTop": "UniverseLanding-module__kHG5Ha__cardTop",
  "closing": "UniverseLanding-module__kHG5Ha__closing",
  "connect": "UniverseLanding-module__kHG5Ha__connect",
  "ctas": "UniverseLanding-module__kHG5Ha__ctas",
  "eyebrow": "UniverseLanding-module__kHG5Ha__eyebrow",
  "featureCard": "UniverseLanding-module__kHG5Ha__featureCard",
  "featureGrid": "UniverseLanding-module__kHG5Ha__featureGrid",
  "footer": "UniverseLanding-module__kHG5Ha__footer",
  "frontOrbit": "UniverseLanding-module__kHG5Ha__frontOrbit",
  "header": "UniverseLanding-module__kHG5Ha__header",
  "headerActions": "UniverseLanding-module__kHG5Ha__headerActions",
  "hero": "UniverseLanding-module__kHG5Ha__hero",
  "heroBottom": "UniverseLanding-module__kHG5Ha__heroBottom",
  "heroCopy": "UniverseLanding-module__kHG5Ha__heroCopy",
  "heroDescription": "UniverseLanding-module__kHG5Ha__heroDescription",
  "knowledge": "UniverseLanding-module__kHG5Ha__knowledge",
  "knowledgeIntro": "UniverseLanding-module__kHG5Ha__knowledgeIntro",
  "knowledgeSymbol": "UniverseLanding-module__kHG5Ha__knowledgeSymbol",
  "labelOne": "UniverseLanding-module__kHG5Ha__labelOne",
  "labelTwo": "UniverseLanding-module__kHG5Ha__labelTwo",
  "languages": "UniverseLanding-module__kHG5Ha__languages",
  "middleOrbit": "UniverseLanding-module__kHG5Ha__middleOrbit",
  "moon": "UniverseLanding-module__kHG5Ha__moon",
  "navigation": "UniverseLanding-module__kHG5Ha__navigation",
  "orbitLabel": "UniverseLanding-module__kHG5Ha__orbitLabel",
  "outerOrbit": "UniverseLanding-module__kHG5Ha__outerOrbit",
  "page": "UniverseLanding-module__kHG5Ha__page",
  "possibilities": "UniverseLanding-module__kHG5Ha__possibilities",
  "primary": "UniverseLanding-module__kHG5Ha__primary",
  "resource": "UniverseLanding-module__kHG5Ha__resource",
  "secondary": "UniverseLanding-module__kHG5Ha__secondary",
  "sectionHeading": "UniverseLanding-module__kHG5Ha__sectionHeading",
  "sphere": "UniverseLanding-module__kHG5Ha__sphere",
  "sphereLines": "UniverseLanding-module__kHG5Ha__sphereLines",
  "star": "UniverseLanding-module__kHG5Ha__star",
  "starfield": "UniverseLanding-module__kHG5Ha__starfield",
  "visual": "UniverseLanding-module__kHG5Ha__visual",
  "visualCaption": "UniverseLanding-module__kHG5Ha__visualCaption",
});
